const CHANGE_STORE_VIEW = 'CHANGE_STORE_VIEW';

export default {
  CHANGE_STORE_VIEW
};
